const API_URL =
  document.domain === "localhost"
    ? "https://jc-creations.co.in/backend"
    : "https://jc-creations.co.in/backend";

const Apis = {
  //Authentication api
  GetUserLogin: `${API_URL}/api/customer/login`,
  GetUserRegsiter: `${API_URL}/api/customer/register`,
  GetCustomerDetails: `${API_URL}/api/customer/getUserByEmailId?email=`,

  //profile
  GetCustomerUpdateDetails: `${API_URL}/api/customer/update`,

  // password reset api
  Resetrequestsend: `${API_URL}/api/customer/sendReset`,
  Otpverify: `${API_URL}/api/customer/verifyOtp`,
  Resetpassword: `${API_URL}/api/customer/resetPassword`,

  //product api
  GetProductById: `${API_URL}/api/product/getWebProductById?id=`,
  GetProductByCategory: `${API_URL}/api/product/getProductByCategory`,
  GetProductByTagSearch: `${API_URL}/api/product/products`,
  GetProductQuerySearchList: `${API_URL}/api/product/search-products?q=`,
  GetNewProductArrivals: `${API_URL}/api/product/getNewArrivals`,
  GetTopSellers: `${API_URL}/api/product/getSellersbyId?id=`,
  DownloadCategoryPdf: `${API_URL}/api/product/downloadCategoryPDF`,

  //order api
  GetOrderCreateByUser: `${API_URL}/api/order/create`,
  GetOrderEmail: `${API_URL}/api/order/orderemail`,
  GetPaymentCapture: `${API_URL}/api/order/paymentcapture`,
  GetRazorpayOrder: `${API_URL}/api/order/razorpayorder`,
  GetPreOrderCreate: `${API_URL}/api/order/preorder`,
  GetOrderByUser: `${API_URL}/api/order/list`,
  GetOrderDownload: `${API_URL}/api/order/download`,

  //category Api"s
  GetAllCategorySubCategoryList: `${API_URL}/api/category/getAllCategory`,

  // Wishlist API
  AddWishlistItem: `${API_URL}/api/wishlist/add`, // Add a new item to the wishlist
  RemoveWishlistItem: `${API_URL}/api/wishlist/remove`, // Remove an item from the wishlist
  GetWishlistItems: `${API_URL}/api/wishlist/find`, // Get all wishlist items for a user

  // Address API
  GetAddressesByCustomerId: `${API_URL}/api/address/list`, // Get addresses for a specific customer

};
export { API_URL, Apis };
